import { render, staticRenderFns } from "./VereadorDetalhes.vue?vue&type=template&id=022069b8&scoped=true"
import script from "./VereadorDetalhes.vue?vue&type=script&lang=js"
export * from "./VereadorDetalhes.vue?vue&type=script&lang=js"
import style0 from "./VereadorDetalhes.vue?vue&type=style&index=0&id=022069b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022069b8",
  null
  
)

export default component.exports